<div class="badge" [ngClass]="design">
    <app-icons *ngIf="icon" [design]="icon"></app-icons>
    <span>
        <ng-content></ng-content>
    </span>
</div>